(function(angular, undefined) {
  angular.module("leptonApp.constants", [])

.constant("appConfig", {
	"userRoles": [
		"guest",
		"user",
		"admin"
	]
})

;
})(angular);


// WEBPACK FOOTER //
// ./public/dev/app/app.constant.js